<div class="title">
  <mat-icon>star</mat-icon>
  Pace Offset
</div>
<div class="description">SELECT Range of the Pace Offset</div>

<div class="options">
  <ngx-slider
    [(value)]="value"
    [(highValue)]="highValue"
    [options]="options"
    (userChange)="changeOffsetFilterRange($event)"
  ></ngx-slider>
</div>

<div class="actions">
  <button styles-button (click)="closeFilterPanel()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
